import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { SubscribedEmailDto } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import { ApplyAsnSubscriptionsApiResultModel, applyAsnSubscriptionsService } from "@WhiteCap/Store/Service/OsnSubscriptionsServices/AsnSubscribersService";

export interface ApplyAsnSubscriptionsApiParameter extends ApiParameter {
    customerId: string;
    subscribedEmails: SubscribedEmailDto[];
    onError?: (error: string) => void;
    onSuccess?: () => void;
}
type HandlerType = CustomApiHandler<ApplyAsnSubscriptionsApiParameter, ApplyAsnSubscriptionsApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/AsnSubscriptions/BeginApplyAsnSubscriptions",
    });
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await applyAsnSubscriptionsService(
        props.apiParameter.customerId,
        props.apiParameter.subscribedEmails,
    );
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter.onSuccess();
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/AsnSubscriptions/ApplyAsnSubscriptionsError",
        });
        return false;
    }
};

export const DispatchCompleteApplyAsnSubscriptions: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/AsnSubscriptions/CompleteApplyAsnSubscriptions",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, MakeApiRequest, DispatchCompleteApplyAsnSubscriptions];

const applyAsnSubscriptions = createHandlerChainRunner(chain, "ApplyAsnSubscriptions");
export default applyAsnSubscriptions;
